/**
 * @typedef {import("../../../../hooks/organization/report/useGetSubSchoolReportById").TeacherReportItem} TeacherReportItem
 */

/**
 * TeacherTableRow component displays a single teacher row
 * @param {object} props - Component props
 * @param {TeacherReportItem} props.teacher - Teacher data from API
 * @param {Function} [props.onClick] - Callback when row is clicked
 * @returns {JSX.Element}
 */
const TeacherTableRow = ({ teacher, onClick }) => {
  // Format classes for display
  const classesDisplay = teacher.classes?.length > 0 ? teacher.classes : ["-"];

  return (
    <tr
      onClick={() => onClick && onClick(teacher)}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      <td>{teacher.teacher_name || "-"}</td>
      <td>
        {classesDisplay.map((cls, idx) => (
          <div key={idx} className="class-list">
            {cls}
          </div>
        ))}
      </td>
      <td>{teacher.students_assigned ?? 0}</td>
      <td>{teacher.avg_student_progress ?? 0}%</td>
      <td>{teacher.pass_rate ?? 0}%</td>
      <td>{teacher.lessons_assigned ?? 0}</td>
      <td>
        <button className="custom-detail-btn">
          <i className="bi bi-three-dots-vertical"></i>
        </button>
      </td>
    </tr>
  );
};

export default TeacherTableRow;
